<template>
    <div
        class="w-full justify-start items-start inline-flex relative overflow-hidden"
    >
        <!-- CIRCLE BACKGROUND GRAPHIC -->
        <div
            class="z-20 absolute w-[275.53px] h-[275.53px] right-0 -translate-y-1/2 translate-x-1/2 circles"
        >
            <!-- -inset-y-24 -end-32 -->
            <div
                class="w-[204.09px] h-[204.09px] left-[27.70px] top-[19.23px] absolute rounded-full shadow border border-orange-400"
            ></div>
            <div
                class="w-[249.91px] h-[249.91px] left-[4.79px] top-[-3.68px] absolute rounded-full shadow border border-orange-400"
            ></div>
            <div
                class="w-[160.36px] h-[160.36px] left-[49.56px] top-[41.09px] absolute rounded-full shadow border border-orange-400"
            ></div>
            <div
                class="w-[116.62px] h-[116.62px] left-[71.43px] top-[62.96px] absolute rounded-full shadow border border-orange-400"
            ></div>
        </div>
        <!-- END CIRCLE GRAPHIC -->
        <div
            class="px-4 py-3 bg-slate-100 rounded-lg flex-col justify-start items-start inline-flex"
        >
            <h3 class="flex-col justify-start items-start gap-1 flex">
                <div class="text-orange-600 text-sm font-medium leading-tight">
                    Need more {{ program?.name }} points?
                </div>
                <div
                    class="self-stretch text-slate-500 text-sm font-normal leading-tight"
                >
                    Here is our top-recommended card you’re eligible for that
                    transfers to
                    {{ program?.name }}. Click on a card to learn more.
                </div>
            </h3>
            <div
                class="self-stretch mt-6 flex-col justify-start items-start gap-2 flex"
            >
                <!-- start single card rec -->
                <div
                    v-for="user in usersWithCardRecs"
                    class="block"
                    :key="`user-${user.id}`"
                >
                    <p v-if="!user.topCard">
                        Unable to recommend a card for this program.
                    </p>
                    <a
                        v-else
                        :href="user.topCard.application_link"
                        target="_blank"
                        class="w-full flex flex-col"
                    >
                        <div
                            class="py-2 rounded-lg justify-start items-center gap-2 inline-flex flex-col"
                        >
                            <div
                                class="h-12 justify-start items-center gap-3 flex"
                            >
                                <div
                                    class="flex-col justify-start items-start gap-2.5 inline-flex"
                                >
                                    <img
                                        class="w-[76px] h-12 rounded shadow"
                                        :src="user.topCard.image"
                                    />
                                </div>
                                <div
                                    class="text-slate-800 text-xs font-medium leading-none"
                                >
                                    {{ user.topCard.title }}
                                </div>
                                <i class="fa-regular fa-chevron-right"></i>
                            </div>
                        </div>
                        <div
                            class="justify-start items-center gap-2 inline-flex"
                        >
                            <i class="fa-thin fa-user fa-sm"></i>
                            <div
                                class="text-slate-500 text-sm font-normal leading-tight"
                            >
                                {{ user.userName }}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end single card rec -->
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useTransferPartnersStore } from '@/store/transferpartners';
import LoadingState from '@/components/ui/loading-state/loading-state.vue';
export default {
    props: {
        program: Object,
        usersWhoNeedCardRecs: Array,
    },
    components: {
        LoadingState,
    },
    setup(props) {
        const transferPartnersStore = useTransferPartnersStore();

        const allCardRecs = computed(
            () => transferPartnersStore.cardRecsByUser
        );

        const usersWithCardRecs = computed(() => {
            return props.usersWhoNeedCardRecs.map((user) => {
                const topCard = allCardRecs.value[user.userId]?.topCards.find(
                    (card) =>
                        transferPartnersStore.allTransferPartners.some(
                            (tp) =>
                                tp.destination_program_id ===
                                    props.program.id &&
                                tp.source_program_id === card.program.id
                        )
                );
                return {
                    userName: user.userName,
                    userId: user.userId,
                    topCard: topCard ? topCard : null,
                };
            });
        });

        return {
            usersWithCardRecs,
        };
    },
};
</script>

<style lang="scss" scoped>
.circles {
    opacity: 0.5;
    mask-image: linear-gradient(to right, transparent, black);
}
</style>
